import { motion } from "framer-motion";

export default function JugadorModeToggle({ mode = "jugador", onChange, showJugador = false, showTecnico = false }) {
    if (!showJugador || !showTecnico) {
        return null;
    }

    const baseClasses = "relative z-10 px-4 md:px-6 py-2.5 text-xs md:text-sm font-bold uppercase tracking-wide rounded-lg transition-colors duration-200";

    return (
        <div className="mb-6 inline-flex p-1 rounded-xl border border-white/10 bg-[#0f1f15] shadow-2xl">
            <button
                type="button"
                onClick={() => onChange?.("jugador")}
                className={`${baseClasses} ${
                    mode === "jugador"
                        ? "text-[#062a1a]"
                        : "text-slate-400 hover:text-white"
                }`}
            >
                {mode === "jugador" ? (
                    <motion.span
                        layoutId="jugador-tecnico-toggle-pill"
                        transition={{ type: "spring", stiffness: 420, damping: 34 }}
                        className="absolute inset-0 -z-10 rounded-lg bg-green-500"
                    />
                ) : null}
                Jugador
            </button>
            <button
                type="button"
                onClick={() => onChange?.("tecnico")}
                className={`${baseClasses} ${
                    mode === "tecnico"
                        ? "text-[#062a1a]"
                        : "text-slate-400 hover:text-white"
                }`}
            >
                {mode === "tecnico" ? (
                    <motion.span
                        layoutId="jugador-tecnico-toggle-pill"
                        transition={{ type: "spring", stiffness: 420, damping: 34 }}
                        className="absolute inset-0 -z-10 rounded-lg bg-green-500"
                    />
                ) : null}
                Técnico
            </button>
        </div>
    );
}
